import { Download, ShieldCheck, Zap, Smartphone } from "lucide-react";
import { API } from "@/lib/api";

export default function DownloadSection({ settings }) {
  const handleDownload = () => {
    if (!settings.download_enabled || !settings.apk_url) return;
    const a = document.createElement("a");
    a.href = `${API}/download`;
    a.rel = "noopener";
    a.setAttribute("download", "");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <section className="bg-[#faf1de] border-y border-[#e0d3b8] py-10 sm:py-12" data-testid="download-section">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="label-navy mb-3">Official Android App</div>
        <div className="mt-2 flex items-center justify-center gap-2 text-[#4a4030] text-sm">
          <Smartphone className="w-4 h-4 text-[#b8860b]" />
          <span>Version <span className="text-[#b8001f] font-bold">{settings.version}</span></span>
          <span className="opacity-40">•</span>
          <span>{(settings.download_count || 0).toLocaleString()} downloads</span>
        </div>

        <p className="mt-4 text-[#4a4030] max-w-xl mx-auto text-sm sm:text-base">
          Fast, secure &amp; always up-to-date. Direct download from the official source.
        </p>

        <div className="mt-6">
          <button
            className="btn-gold text-base sm:text-lg !py-4 !px-12"
            onClick={handleDownload}
            disabled={!settings.download_enabled || !settings.apk_url}
            data-testid="download-apk-button"
          >
            <Download className="w-5 h-5" />
            {settings.button_text || "Download APK"}
          </button>
        </div>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-[#6b6455]">
          <span className="flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-[#b8860b]" /> Verified safe</span>
          <span className="flex items-center gap-1.5"><Zap className="w-4 h-4 text-[#b8860b]" /> Fast direct download</span>
          <span className="flex items-center gap-1.5"><Smartphone className="w-4 h-4 text-[#b8860b]" /> Android 7.0+</span>
        </div>
      </div>
    </section>
  );
}
